import { ShotChartData } from "../../../models/TableData";

export interface ParsedShotData {
  x: number;
  y: number;
  made?: number;
  attempts?: number;
}

/**
 * Parse shot chart data from the API format
 */
export const parseShotChartData = (data: ShotChartData): ParsedShotData[] => {
  try {
    return JSON.parse(
      data.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ')
    );
  } catch (e) {
    console.error('Failed to parse shot chart data:', e);
    return [];
  }
};
